import { create } from "zustand";
import { persist } from "zustand/middleware";
import { api } from "../lib/api";
import type { Tenant } from "@shared/types";

interface TenantState {
  currentTenantId: string | null;
  available: Tenant[];
  setTenant: (id: string) => void;
  loadAvailable: () => Promise<void>;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenantId: null,
      available: [],
      setTenant: (id) => set({ currentTenantId: id }),
      loadAvailable: async () => {
        const list = await api<Tenant[]>("/api/tenants");
        set((s) => ({
          available: list,
          currentTenantId: s.currentTenantId ?? list[0]?.id ?? null,
        }));
      },
    }),
    { name: "vr-tenant", partialize: (s) => ({ currentTenantId: s.currentTenantId }) },
  ),
);
